import * as yup from "yup";

const DEFAULT_MESSAGE = "Este campo es requerido."

const authorSchema = yup.object().shape({
    name: yup.string().required(DEFAULT_MESSAGE),
    description : yup.string().required(DEFAULT_MESSAGE),
    email: yup.string().email().required(DEFAULT_MESSAGE),
    url: yup.string().url().required(DEFAULT_MESSAGE),
    thumbnail:  yup
    .number()
    .moreThan(0, "Selecciona una imagen")
    .required("Seleccione una imagen."),
});

export {
    authorSchema
}